<div class="header-container">
  <app-header></app-header>
</div>
<div
  class="flex justify-center items-center bg-[#ECF7FF] p-4 onboarding-container py-20"
>
  <div class="bg-white p-8 shadow-lg w-[70%]">
    <app-stepper [currentStep]="activeStep"></app-stepper>

    <!-- Company Selection Section (when coming from dashboard with multiple companies) -->
    <div
      *ngIf="isComingFromDashboard && userCompanies.length > 1"
      class="mb-8 p-4 bg-blue-50 rounded-lg"
    >
      <h3 class="text-lg font-semibold text-gray-800 mb-4">
        {{ "ONBOARDING.SELECT_COMPANY" | translate }}
      </h3>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div
          *ngFor="let company of userCompanies"
          class="border rounded-lg p-4 cursor-pointer transition-all hover:shadow-md"
          [class.border-blue-500]="selectedCompany?.id === company.id"
          [class.bg-blue-50]="selectedCompany?.id === company.id"
          [class.border-gray-200]="selectedCompany?.id !== company.id"
          (click)="selectCompany(company)"
        >
          <h4 class="font-medium text-gray-800">
            {{ company.companyName || company.nameEn }}
          </h4>
          <p class="text-sm text-gray-600">
            {{ "ONBOARDING.CR" | translate }}: {{ company.crNumber }}
          </p>
          <p class="text-sm text-gray-500">
            {{ company.companyNameArabic || company.nameAr }}
          </p>
        </div>
      </div>
    </div>

    <!-- Loading indicator for company data -->
    <div *ngIf="isLoading" class="flex justify-center items-center mb-8">
      <div
        class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"
      ></div>
      <span class="ml-2 text-gray-600">{{
        "ONBOARDING.SAVING_COMPANY" | translate
      }}</span>
    </div>

    <form [formGroup]="onboardingForm">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-12 mb-8">
        <div>
          <label
            for="crNumber"
            class="block text-sm font-medium text-gray-700 mb-1"
            >{{ "ONBOARDING.CR_NUMBER" | translate }}</label
          >
          <input
            type="text"
            id="crNumber"
            formControlName="crNumber"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            for="companyNameArabic"
            class="block text-sm font-medium text-gray-700 mb-1"
            >{{ "ONBOARDING.COMPANY_NAME_ARABIC" | translate }}</label
          >
          <input
            type="text"
            id="companyNameArabic"
            formControlName="companyNameArabic"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            for="policyStartDate"
            class="block text-sm font-medium text-gray-700 mb-1"
            >{{ "ONBOARDING.POLICY_START_DATE" | translate }}</label
          >
          <input
            type="date"
            id="policyStartDate"
            formControlName="policyStartDate"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
          <div
            *ngIf="savedPolicyStartDate"
            class="text-xs text-green-600 mt-1 flex items-center"
          >
            <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              ></path>
            </svg>
            {{ "ONBOARDING.DATE_SAVED_MESSAGE" | translate }}
          </div>
        </div>
        <div>
          <label
            for="phoneNumber"
            class="block text-sm font-medium text-gray-700 mb-1"
            >{{ "ONBOARDING.PHONE_NUMBER" | translate }}</label
          >
          <input
            type="text"
            id="phoneNumber"
            formControlName="contactPhone"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            for="companyNameEnglish"
            class="block text-sm font-medium text-gray-700 mb-1"
            >{{ "ONBOARDING.COMPANY_NAME_ENGLISH" | translate }}</label
          >
          <input
            type="text"
            id="companyName"
            formControlName="name"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            for="numberOfEmployees"
            class="block text-sm font-medium text-gray-700 mb-1"
            >{{ "ONBOARDING.NUMBER_OF_EMPLOYEES" | translate }}</label
          >
          <input
            type="number"
            id="numberOfEmployees"
            formControlName="numberOfEmployees"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            for="sponsorID"
            class="block text-sm font-medium text-gray-700 mb-1"
            >{{ "ONBOARDING.SPONSOR_ID" | translate }}</label
          >
          <input
            type="text"
            id="sponsorID"
            formControlName="sponsorID"
            placeholder="{{ 'ONBOARDING.SPONSOR_ID_PLACEHOLDER' | translate }}"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            for="entity700Number"
            class="block text-sm font-medium text-gray-700 mb-1"
            >{{ "ONBOARDING.ENTITY_700_NUMBER" | translate }}</label
          >
          <input
            type="text"
            id="entity700Number"
            formControlName="entity700Number"
            placeholder="{{ 'ONBOARDING.ENTITY_700_PLACEHOLDER' | translate }}"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>

      <div class="flex justify-between">
        <button
          class="px-6 py-2 border rounded-md text-gray-700 hover:bg-gray-50"
          (click)="handleBack()"
        >
          {{ "COMMON.BACK" | translate }}
        </button>

        <button
          type="button"
          (click)="onContinue()"
          class="px-6 py-2 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          {{ "COMMON.CONTINUE" | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
<app-footer layout="slim"></app-footer>
